import { Directive } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Directive({
  selector: '[appDoubleExtCheck]'
})
export class DoubleExtCheckDirective {

  constructor(private toastr : ToastrService) { }

  checkDoubleExtension(filename) {
    console.log(filename);
    var ext = filename.match(/\.(.+)$/)[1];
    if (ext.indexOf('.') !== -1) {
      this.toastr.error("Filename with two extensions is not supported.");
      return 0;
    }
    return 1;
  }


}
